{
  "wave": {
    "name": "Wave",
    "description": "Quick payment via Wave",
    "instructions": "You will receive a Wave notification to confirm the payment",
    "ussd_prompt": "Dial *1* to confirm"
  },
  "orange_money": {
    "name": "Orange Money",
    "description": "Payment via Orange Money",
    "instructions": "Dial #144# to confirm the payment",
    "ussd_prompt": "Enter your Orange Money PIN"
  },
  "cash_on_delivery": {
    "name": "Cash on delivery",
    "description": "Pay in cash when your order is delivered"
  },
  "status": {
    "pending": "Waiting for payment",
    "processing": "Processing",
    "confirmed": "Payment confirmed",
    "failed": "Payment failed",
    "timeout": "Timed out",
    "refunded": "Refunded"
  },
  "errors": {
    "network": "Connection error. Please check your network.",
    "invalid_phone": "Invalid phone number",
    "insufficient_funds": "Insufficient funds",
    "provider_unavailable": "Service temporarily unavailable",
    "invalid_amount": "Invalid amount",
    "timeout": "Confirmation timed out. Please try again.",
    "unknown": "An unexpected error occurred"
  },
  "actions": {
    "retry": "Retry",
    "cancel": "Cancel payment",
    "change_method": "Change payment method"
  }
}
